













import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class UploadImg extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly imageList!: string[]

  handlePreview(image: string) {
    this.$wechat.wx.previewImage({
      current: image,
      urls: this.imageList
    })
  }

  handleDeleteImg(index: number) {
    this.$emit('del-img', index)
  }

  handleAddImg() {
    this.$wechat.wx.chooseImage({
      count: 3 - this.imageList.length,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      success: (res: any) => {
        this.$emit('add-img', res.localIds)
      }
    })
  }
}
